import { render, staticRenderFns } from "./ExecutiveDashboardProfile12.vue?vue&type=template&id=2b4f8657&scoped=true&"
import script from "./ExecutiveDashboardProfile12.vue?vue&type=script&lang=js&"
export * from "./ExecutiveDashboardProfile12.vue?vue&type=script&lang=js&"
import style0 from "./ExecutiveDashboardProfile12.vue?vue&type=style&index=0&id=2b4f8657&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4f8657",
  null
  
)

export default component.exports